define(
    'views/search-suggestions',[
        'jquery',

        'connections/search-suggestions-connection',

        'utils/is-fixed',
        'utils/debounce',

        'libs/mousetrap/mousetrap.min',
    ],

    function ($, SearchSuggestionsConnection, isFixed, debounce, MouseTrap) {
        function SearchSuggestionsLive () {}

        /**
         * The class applied to focused suggestions
         *
         * @property focusedClass
         * @type {string}
         */
        SearchSuggestionsLive.prototype.focusedClass = 'search-suggestions-live__focused';

        /**
         * Initializes the bindings
         *
         * @method _init
         * @private
         */
        SearchSuggestionsLive.prototype.init = function () {
            var _this = this;
            var $input = $('#search-query');

            // Check if search input exists.
            // Search input is hidden when Not Commerce Site is enabled in Epi.
            if (!$input.length) return;

            this.$searchSuggestionsContainer = $('.search-suggestions-live');
            this.$loader = _this.$searchSuggestionsContainer.find('.search-suggestions-live__loading');
            
            this._positionRelativeToField($input);

            $input.on('focus', function() {
                _this._positionRelativeToField($(this));
                if (_this._hasQuery()) _this.setActive(true);
            });

            $input.on('input', debounce(function() {
                _this.query = $(this).val();

                if (!_this._hasQuery()) {
                    _this.setActive(false);
                    _this.$searchSuggestionsContainer.find('.search-suggestions-live__results').empty();
                    return;
                }

                _this._positionRelativeToField($(this));
                _this.getSearchSuggestions(_this.query);
                _this.setActive(true);
            }, 400));
            
            $('#search-query').on('blur', function() { 
                _this.setActive(false);
            });

            $(window).on('scroll', function() {
                _this.setActive(false);
            });
        };

        /**
         * Binds the key shortcuts
         *
         * @method _keysBind
         * @private
         */
        SearchSuggestionsLive.prototype._keysBind = function () {
            var _this = this;

            MouseTrap.bind('down', function (event) {
                event.preventDefault();

                _this._removeFocusedStateAndReturn('next')
                    .addClass(_this.focusedClass);
            });

            MouseTrap.bind('up', function (event) {
                event.preventDefault();

                _this._removeFocusedStateAndReturn('previous')
                    .addClass(_this.focusedClass);
            });

            MouseTrap.bind('enter', function (event) {
                var focused = _this._getFocused();

                if (focused.length > 0) {
                    event.preventDefault();

                    location.href = focused.find('a').attr('href');
                }
            });
        };

        /**
         * Unbinds the key shortcuts
         *
         * @method _keysUnbind
         */
        SearchSuggestionsLive.prototype._keysUnbind = function () {
            Mousetrap.unbind('up');
            Mousetrap.unbind('down');
            Mousetrap.unbind('enter');
        };

        /**
         * Removes the focused state of off an item and returns the next
         * or the previous one
         *
         * @method _removeFocusedStateAndReturn
         * @param direction
         * @returns {*}
         * @private
         */
        SearchSuggestionsLive.prototype._removeFocusedStateAndReturn = function (direction) {
            var focused = this._getFocused();

            if (focused.length > 0) {
                focused.removeClass(this.focusedClass);
                var newFocus = (direction === 'next')? focused.next() : focused.prev();
                if (newFocus.length > 0) return newFocus;
                
                newFocus = focused.parent().siblings('ul').find('li');
                return (direction === 'next')? newFocus.eq(0) : newFocus.last();
            }

            return (direction === 'next') ? $('.search-suggestions-live li').eq(0) : $('.search-suggestions-live li').last();
        };

        /**
         * Get the currently focused item
         *
         * @method _getFocused
         * @returns {*}
         * @private
         */
        SearchSuggestionsLive.prototype._getFocused = function () {
            return $('.search-suggestions-live__focused').eq(0);
        };

        /**
         * Checks if any query actually has been entered
         *
         * @method _hasQuery
         * @returns {boolean}
         * @private
         */
        SearchSuggestionsLive.prototype._hasQuery = function () {
            return (this.query !== undefined && this.query.length !== undefined && this.query.length > 2);
        };

        /**
         * Search for products
         *
         * @method getSearchSuggestions
         */
        SearchSuggestionsLive.prototype.getSearchSuggestions = function(q) {
            var _this = this;

            this.$loader.show();
            SearchSuggestionsConnection.getSearchSuggestions(q).then(function(html) {
                _this.printSearchSuggestions(html);
            }).always(function() {
                _this.$loader.slideUp(100);
            });
        };

        /**
         * Print the partial view 
         *
         * @method printSearchSuggestions
         */
        SearchSuggestionsLive.prototype.printSearchSuggestions = function(html) {
            this.$searchSuggestionsContainer.find('.search-suggestions-live__results').html(html);
        };

         /**
         * Positions the DOM elements relative to the given field.
         * Automatically detects whether or not the parent has a fixed position.
         *
         * @method _positionRelativeToField
         * @param el
         * @private
         */
        SearchSuggestionsLive.prototype._positionRelativeToField = function (el) {
            var offset, position;

            if (isFixed(el)) {
                position = 'fixed';
                offset = {
                    top: el.offset().top - $(window).scrollTop(),
                    left: el.offset().left - $(window).scrollLeft()
                };
            } else {
                position = 'absolute';
                offset = el.offset();
            }

            this.$searchSuggestionsContainer.css({
                position: position,
                top: offset.top + el.outerHeight(),
                right: $(window).width() - (offset.left + el.outerWidth())
            });
        };

         /**
         * Set whether or not the suggestion display are active
         *
         * @method _setActive
         * @param active
         * @private
         */
        SearchSuggestionsLive.prototype.setActive = function (active) {
            if (active) {
                this.$searchSuggestionsContainer.fadeIn(120);
                this._keysBind();
            }
            else {
                this.$searchSuggestionsContainer.fadeOut(120);
                this._keysUnbind();
            }
        };

        return new SearchSuggestionsLive();
    }

);

